import { render, staticRenderFns } from "./importData.vue?vue&type=template&id=c630c0ae&scoped=true&"
import script from "./importData.vue?vue&type=script&lang=js&"
export * from "./importData.vue?vue&type=script&lang=js&"
import style0 from "./importData.vue?vue&type=style&index=0&id=c630c0ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c630c0ae",
  null
  
)

export default component.exports